import { connect } from 'react-redux';

import BaseComponent from '../../components/BaseComponent';
import { employeeProjects } from '../../entity/CMS/employeeProjectsConfig';

class EmployeeProjects extends BaseComponent {
  constructor(props) {
    super(props);
    this.config = { ...employeeProjects };
    this.getResponse();
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(EmployeeProjects);
